export default "__VITE_ASSET__BzI8SwM9__"